<template>
    <div class="modal fade" id="submitFilesModal" tabindex="-1" aria-labelledby="submitFilesModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="submitFilesModalLabel">Submit Files</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleSubmit">
              <div v-if="required_file_paths">
                <h6>Required Files</h6>
                <div v-if="submitted && !allRequiredFilesSelected" class="alert alert-danger" role="alert">
                  All required files must be uploaded.
                </div>
                <ul>
                  <li v-for="fileName in requiredFileNames" :key="fileName">{{ fileName }}</li>
                </ul>
                <label for="required_files" class="form-label">Upload Required Files</label>
                <input type="file" class="form-control" id="required_files" multiple @change="handleFileChange($event)" ref="inputFile">
              </div>
              <div v-else class="mb-3">
                <div v-if="multiple">
                  <label for="files_to_submit" class="form-label">Upload Files</label>
                  <input type="file" class="form-control" id="files_to_submit" multiple :accept="accept" @change="handleFileChange($event)" ref="inputFile">
                </div>
                <div v-else>
                  <label for="files_to_submit" class="form-label">Upload File</label>
                  <input type="file" class="form-control" id="files_to_submit" :accept="accept" @change="handleFileChange($event)" ref="inputFile">
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SubmitFilesModal',
    props: {
      required_file_paths: {
        type: Array,
        required: false
      },
      multiple: {
        type: Boolean,
        default: true
      },
      // Optional advisory file-picker filter, e.g. ".pdf,.md,.txt" (real validation
      // stays in the parent's submit handler; the accept attr is only a UX hint).
      accept: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        files_to_submit: [],
        submitted: false
      };
    },
    computed: {
      allRequiredFilesSelected() {
        if (!this.required_file_paths) return true;
        return this.required_file_paths.every(file => 
          this.files_to_submit.some(f => f.name === this.getFileName(file))
        );
      },
      requiredFileNames() {
        return this.required_file_paths ? this.required_file_paths.map(this.getFileName) : [];
      }
    },
    async mounted() {
      console.log('mounted');
      const modalElement = document.getElementById('submitFilesModal');
      modalElement.addEventListener('hidden.bs.modal', this.resetForm);
    },
    methods: {
      resetForm() {
        this.files_to_submit = [];
        this.submitted = false;
        if (this.$refs.inputFile) {
          this.$refs.inputFile.value = '';
        }
      },
      getFileName(filePath) {
        return filePath.split('/').pop();
      },
      handleFileChange(event) {
        this.files_to_submit = Array.from(event.target.files);
      },
      async handleSubmit() {
        this.submitted = true;
        if (!this.allRequiredFilesSelected) {
          return;
        }
        // Dismiss the modal by clicking the close button
        this.$el.querySelector('.btn-close').click();
        this.$emit('submitForm', this.files_to_submit);
      },
    },
  };
  </script>